export const DOCCHAT_SELECTION_QUOTE_MAX_LENGTH = 1000

export interface DocChatSelectionRect {
  top: number
  left: number
  width: number
  height: number
}

export interface DocChatSelectionRange {
  commonAncestorContainer: unknown
  getBoundingClientRect(): DocChatSelectionRect
}

export interface DocChatSelectionLike {
  isCollapsed: boolean
  rangeCount: number
  toString(): string
  getRangeAt(index: number): DocChatSelectionRange
}

export interface DocChatSelectedQuote {
  text: string
  rect: DocChatSelectionRect
}

/**
 * The text the user selected inside the answer, with its on-screen rectangle
 * so the feedback bar can anchor to it. Null when nothing usable is selected.
 */
export function readDocChatSelection(
  selection: DocChatSelectionLike | null,
  isInsideAnswer: (node: unknown) => boolean
): DocChatSelectedQuote | null {
  if (!selection || selection.isCollapsed || selection.rangeCount === 0) {
    return null
  }
  const range = selection.getRangeAt(0)
  if (!isInsideAnswer(range.commonAncestorContainer)) return null

  const text = selection.toString().trim()
  if (!text) return null

  return {
    text: text.slice(0, DOCCHAT_SELECTION_QUOTE_MAX_LENGTH),
    rect: range.getBoundingClientRect(),
  }
}

export const DOCCHAT_SELECTION_BAR_ATTRIBUTE = 'data-docchat-selection-bar'
